import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import HealthCheckCheckItem from './HealthCheckCheckItem';
import { CHECK_KEY_LABELS } from './constants';

const Panel = styled.div`
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
`;

function buildChecks(attempt, checkItems, defaultCheckValue) {
  if (attempt.checksList && attempt.checksList.length > 0) {
    return attempt.checksList.map(check => ({
      key: check.check_key,
      label: CHECK_KEY_LABELS[check.check_key] || (check.check_key || '').replace(/-/g, ' '),
      passed: check.status === 'passed',
      message: check.message,
      evidence: check.evidence,
    }));
  }
  return checkItems.map(({ key, label }) => ({
    key,
    label,
    passed: attempt.checks[key] ?? defaultCheckValue,
    message: null,
    evidence: null,
  }));
}

export default function HealthCheckAttemptCard({ attempt, checkItems, defaultCheckValue }) {
  const checks = buildChecks(attempt, checkItems, defaultCheckValue);

  return (
    <Panel>
      {checks.map(({ key, label, passed, message, evidence }) => (
        <HealthCheckCheckItem
          key={key}
          label={label}
          passed={passed}
          message={message}
          evidence={evidence}
        />
      ))}
    </Panel>
  );
}

HealthCheckAttemptCard.propTypes = {
  attempt: PropTypes.object.isRequired,
  checkItems: PropTypes.array.isRequired,
  defaultCheckValue: PropTypes.bool,
};

HealthCheckAttemptCard.defaultProps = {
  defaultCheckValue: false,
};
